import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';

const Services = ({ isAdmin = false, onEditClick }) => {
  const navigate = useNavigate();
  const [servicesData, setServicesData] = useState({
    heading: "",
    description: "",
    services: [],
    button: {
      text: "",
      url: ""
    }
  });
  const [isLoading, setIsLoading] = useState(true);

  const colors = {
    background: '#ffffff',
    primary: '#0760ad',
    secondary: '#098a48',
    text: '#2a3b47',
    muted: '#6b7280'
  };

  useEffect(() => {
    const fetchServicesData = async () => {
      try {
        const response = await fetch(`${import.meta.env.VITE_API_URL}/home/services/`);
        if (response.ok) {
          const data = await response.json();
          setServicesData({
            heading: data.heading || "Services We Provide",
            description: data.description || "Medical consultations, diagnostic tests, preventive screenings...",
            services: data.services || [],
            button: data.button || {
              text: "Explore Health Packages",
              url: "/health-packages"
            }
          });
        }
      } catch (error) {
        console.error('Error fetching services data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchServicesData();
  }, []);

  if (isLoading) {
    return (
      <div className="bg-white p-8 min-h-[400px] flex items-center justify-center">
        <span className="loading loading-spinner loading-lg"></span>
      </div>
    );
  }

  return (
    <div className="bg-white p-8 relative text-justify">
      {isAdmin && (
        <button 
          onClick={onEditClick}
          className="absolute top-4 right-4 btn btn-sm btn-primary z-10"
        >
          Edit Section
        </button>
      )}
      
      <div className="container mx-auto border-b-2">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4" style={{ color: colors.text }}>
            {servicesData.heading}
          </h1>
          <p className="max-w-2xl mx-auto text-lg" style={{ color: colors.muted }}>
            {servicesData.description}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
          {servicesData.services.map((service, index) => (
            <div 
              key={index}
              className="flex flex-col items-center text-center p-6 rounded-lg transition-all duration-300 hover:shadow-lg hover:-translate-y-1 cursor-pointer"
              style={{ 
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                border: '1px solid rgba(0, 0, 0, 0.05)'
              }}
              onClick={() => service.url && navigate(service.url)}
            >
                <img 
                  src={service.icon} 
                  alt={service.title} 
                  className="w-12 h-12 mb-4 object-contain"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = 'https://via.placeholder.com/48?text=Icon';
                  }}
                />
              
              <h3 className="text-lg font-semibold" style={{ color: colors.text }}>
                {service.title}
              </h3>
            </div>
          ))}
        </div>

        {servicesData.button?.text && (
          <div className="text-center mb-12">
            <button
              onClick={() => navigate(servicesData.button.url)}
              className="px-8 py-4 rounded-full text-white font-bold text-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 flex items-center justify-center mx-auto"
              style={{
                background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`,
                border: 'none',
                outline: 'none',
                cursor: 'pointer',
                position: 'relative',
                overflow: 'hidden',
                minWidth: '280px'
              }}
            >
              <span className="relative z-10 flex items-center">
                {servicesData.button.text}
                <FaArrowRight className="ml-2" />
              </span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Services;